import {
  alpha,
  keyframes,
  Paper,
  SxProps,
  Theme,
  useTheme,
} from '@mui/material'

type TProps = {
  sx?: SxProps<Theme>
  className?: string
}
function LoadingPaperSkeleton({ sx = {}, className = '' }: TProps) {
  const diagonalWave = keyframes`
    0% {
      transform: translate(-100%, -100%);
    }
    100% {
      transform: translate(100%, 100%);
    }
  `
  const theme = useTheme()
  return (
    <Paper
      className={className}
      sx={{
        width: '100%',
        height: '100%',
        background: alpha(theme.palette.common.white, 0.9),
        position: 'relative',
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '180%',
          height: '200%',
          background: `linear-gradient(135deg, rgba(0, 0, 0, 0) 30%, ${theme.palette.mainBackground} 50%, rgba(0, 0, 0, 0) 70%)`,
          animation: `${diagonalWave} 2s linear infinite`,
        },
        ...sx,
      }}
    />
  )
}
export default LoadingPaperSkeleton
